export default "__VITE_ASSET__962dd373__"